
import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '../Assets/WebsiteCss/homepage.css';
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { FaTools, FaIndustry, FaCogs, FaBoxOpen } from "react-icons/fa";
import { FaUserTie, FaHardHat } from 'react-icons/fa';
import { GiCookingPot } from 'react-icons/gi';
import { MdPrecisionManufacturing } from 'react-icons/md';
import { BiGroup } from 'react-icons/bi';

import banner1 from '../Assets/Image/namkeenprductsabout.png'
import banner2 from '../Assets/Image/namkeen-maker-worker.jpg'
import banner3 from '../Assets/Image/automatic-continuous-namkeen-fryer-machine-500x500.webp'
import banner4 from '../Assets/Image/NS_Namkeensbabber3.webp'
import banner5 from '../Assets/Image/NS_Namkeensbabber5.jpg'
import banner6 from '../Assets/Image/frontbannerimg.png'
import aboutimg from '../Assets/Image/Home labour contractor.avif'
import sohanpapadi from '../Assets/Image/Sohan Papdi.jpg'
import alubhujiya from '../Assets/Image/alubhujiya.png'
import dryfruitmix from '../Assets/Image/DryfruitMix.png'
import chanamasala from '../Assets/Image/cganajormasala.png'
import indori from '../Assets/Image/endorikhattamitha.png'
import fariyalisabudana from '../Assets/Image/FariyaliSabudana.png'
import gujaratimix from '../Assets/Image/Gujaratimix.png'
import moongdal from '../Assets/Image/MoongdalMasala.png'

import { useNavigate } from 'react-router-dom';

import contactlabour from '../Assets/Image/ContactLabour.png'

import { Helmet } from "react-helmet";


export default function HomePage() {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const products = [
    { name: "Sohan Papdi", image: sohanpapadi },
    { name: "Alu Bhujiya", image: alubhujiya },
    { name: "Dry Fruit Mix", image: dryfruitmix },
    { name: "Chana Jor Masala", image: chanamasala },
    { name: "Indori Khatta Mitha", image: indori },
    { name: "Fariyali Sabudana", image: fariyalisabudana },
    { name: "Gujarati Papdi", image: gujaratimix },
    { name: "Moong Daal (Masala)", image: moongdal },
  ];

  const testimonials = [
    "Absolutely the best namkeen I've ever had! The flavors are authentic and fresh!",
    "Perfect crunch and spice! My family loves it.",
    "Crispy and flavorful! Reminds me of traditional homemade snacks.",
    "Delicious namkeen with great quality! Highly recommend it."
  ];

  const serviceFeatures = [
    {
      title: "Supervisor",
      icon: <FaUserTie size={40} color="#DC4321" />,
      description:
        "Skilled professionals with experience in managing namkeen production units, ensuring smooth operations, labor management, and production timelines.",
    },
    {
      title: "Namkeen Karigars / Operators",
      icon: <GiCookingPot size={40} color="#DC4321" />,
      description:
        "Expert Karigars trained in preparing authentic Rajasthani namkeen with precise techniques to maintain taste, texture, and tradition.",
    },
    {
      title: "Packaging Machine Operators",
      icon: <MdPrecisionManufacturing size={40} color="#DC4321" />,
      description:
        "Trained workers who operate, monitor, and maintain automatic/semi-automatic namkeen packaging machines efficiently.",
    },
    {
      title: "Semi-Skilled Karigars",
      icon: <FaHardHat size={40} color="#DC4321" />,
      description:
        "Support staff who assist in frying, seasoning, mixing, and moving products as per supervisor's instructions.",
    },
  ];

  return (


<>
<div className="mainnav min-vh-100 ">

    <Helmet>
      <title>Narayan Salvi Namkeen | Premium Namkeen Manufacturer Since 1997</title>
      <meta
        name="description"
        content="Narayan Salvi Namkeen – Bringing 300+ authentic flavors with complete labour contracting solutions. Taste the tradition with quality, freshness, and real ingredients."
      />
      <meta name="keywords" content="Namkeen Manufacturer, Namkeen Labour Contractor, Bikaneri Bhujiya, Indore Mixture, Ratlami Sev, Namkeen Supplier India, Narayan Salvi, Snacks Manufacturer, Namkeen Packing Labour" />
      <meta name="author" content="Narayan Salvi Namkeen" />

      {/* Open Graph for Social Media */}
      <meta property="og:title" content="Narayan Salvi Namkeen | Premium Namkeen Manufacturer" />
      <meta property="og:description" content="Explore 300+ authentic namkeen flavors crafted by experts with over 27 years of experience." />
      <meta property="og:image" content="https://nsnamkeenlabourcontractor.com/" />
      <meta property="og:url" content="https://nsnamkeenlabourcontractor.com/" />
      <meta property="og:type" content="website" />

      {/* Mobile Responsive Meta */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />
    </Helmet>

     <Swiper
  spaceBetween={20}
  centeredSlides={true}
  loop={true} // enable infinite loop
  speed={1000} // transition speed in ms (1s)
  autoplay={{ delay: 3000, disableOnInteraction: false }}
  pagination={{ clickable: true }}
  navigation={true}
  grabCursor={true} // smoother drag feel
  modules={[Autoplay, Pagination, Navigation]}
  className="custom-swiper"
>
  <SwiperSlide>
    <img className="slide-image" src={banner1} alt="Namkeen Manufacturer" />
    <div className="slide-text">
      <h2>Welcome To Narayan Salvi Namkeen Manufacturer Labour Contractor</h2>
    </div>
  </SwiperSlide>
  <SwiperSlide>
    <img className="slide-image" src={banner6} alt="Real Tasty Namkeen" />
    <div className="slide-text">
      <h3>Delicious Namkeen – Freshly Made, Always Authentic!</h3>
    </div>
  </SwiperSlide>

  <SwiperSlide>
    <img className="slide-image" src={banner5} alt="Traditional Indian Namkeen Thali" />
    <div className="slide-text">
      <h3>Authentic Indian Thali Experience with Expert-Crafted Namkeen Delights</h3>
    </div>
  </SwiperSlide>

  <SwiperSlide>
    <img className="slide-image" src={banner2} alt="Real Tasty Namkeen" />
    <div className="slide-text">
      <h3>Complete Labour Contracting Solutions – From Skilled Karigars to Modern Machinery</h3>
    </div>
  </SwiperSlide>

  <SwiperSlide>
    <img className="slide-image" src={banner4} alt="Real Tasty Namkeen" />
    <div className="slide-text">
      <h3>Authenticity in Every Bite – Made with Real Ingredients You Can Trust</h3>
    </div>
  </SwiperSlide>

  <SwiperSlide>
    <img className="slide-image" src={banner3} alt="Real Tasty Namkeen" />
    <div className="slide-text">
      <h3>Expert-Driven Labour Support for Hassle-Free Namkeen Manufacturing</h3>
    </div>
  </SwiperSlide>
</Swiper>


      <Container className='mt-3'>
        <div className="mb-2 mt-3" >
          <h2 className="middletext mb-3" data-aos="zoom-in">About Us</h2>
          <Row>
            <Col lg={5} className="d-flex justify-content-center" >
              <img
                src={aboutimg}
                alt=""
                style={{ height: "300px", width: '90%', objectFit: 'fill', borderRadius: "8px" }}
              />
            </Col>
            <Col lg={7}>
              <p style={{ textAlign: "justify" }}>
                At Narayan Salvi Group of Namkeen Labour Contractor , we take pride in our 27 years of expertise in crafting premium-quality namkeen products. Founded by Narayan Salvi, a seasoned professional in the industry, we specialize in a diverse range of namkeen, including Bikaneri Moth Bhujiya, Indore Khatta Meetha Mixture, Special Ratlami Sev, Mast Kirn, Delhi Mix, Navratan Mix, Singh Bhujiya, Peanuts, Special Long Sev, Bombay Mix, Mungdaal, and over 300+ unique namkeen varieties.

                Our mission is to deliver superior-quality snacks that delight taste buds across India. We have successfully completed numerous contracts, offering end-to-end solutions from manufacturing to packaging, ensuring freshness, authenticity, and excellence in every bite.

                With a commitment to tradition and innovation, we continue to expand our reach, bringing authentic flavors to more people and regions. Join us on our journey as we redefine taste and quality in the world of namkeen.
              </p>
            </Col>
          </Row>
        </div>

        <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
          <Container>
            <Row className="text-center mb-4">
              <Col>
                <h2
                  className="fw-bold text-uppercase"
                  style={{ color: "#23326a" }}
                  data-aos="zoom-in"
                >
                  Complete Labour Contract Solutions
                </h2>
                <p className="lead text-muted">
                  We provide <b>end-to-end labour contracting</b> from{" "}
                  <b>manufacturing to final packing</b>, utilizing{" "}
                  <b>automatic & hand machinery</b> for the best efficiency.
                  <br />

                </p>
                <b>We Provide Services : </b>
              </Col>
            </Row>

            <Row >
              {/* Left Side - Image */}
              <Col md={6} className="text-center">
                <img
                  src={contactlabour}
                  alt="Labour Machinery"
                  className="img-fluid rounded shadow-lg"
                  style={{ height: "350px" }}
                />
              </Col>

              {/* Right Side - Features */}
              <Col md={6}>
                <Row>
                  {serviceFeatures.map((service, idx) => (
                    <Col md={6} key={idx} className='mb-3'>
                      <Card className="mb-3 border-0 shadow-sm h-100">
                        <Card.Body className="text-center">
                          {service.icon}
                          <h5 className="mt-3">{service.title}</h5>
                        </Card.Body>
                      </Card>
                     
                    </Col>
                    
                  ))}
                   <div className="d-flex justify-content-center mt-2">
            <Button className="custom-btn"
             onClick={() => navigate('/services')}>
              More <FaArrowRight className="ml-2" />
            </Button>
          </div>
                </Row>
              </Col>
              
            </Row>
            
          </Container>
        </section>


        <div className="mb-2 mt-1">
          <h2 className="middletext mb-4" data-aos="zoom-in"> Our Delicious Namkeen Range </h2>
          <Row>
            {products.map((product, index) => (
              <Col md={3} sm={6} xs={6} key={index} className="mb-4">
                <div className="product-box">
                  <img src={product.image} alt={product.name}
                    className="product-img" style={{ height: '200px' }} />
                  <div className="overlay">
                    <h5>{product.name}</h5>
                  </div>
                </div>
              </Col>
            ))}

          </Row>
          <div className="d-flex justify-content-center mt-2">
            <Button className="custom-btn" onClick={() => navigate('/ourproducts')}>
              More <FaArrowRight className="ml-2" />
            </Button>
          </div>
        </div>

        <div className="mb-5 mt-5">
          <Row className="justify-content-center">
            <h2 className="middletext" data-aos="zoom-in">
              What Our Customers Say
            </h2>
            <Col md={7} className="testimonial-container text-center">

              <Row className="justify-content-center">
                <Col md={11}>
                  <Swiper
                    spaceBetween={20}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                    modules={[Autoplay, Pagination]}
                    className="testimonial-swiper"
                  >
                    {testimonials.map((feedback, index) => (
                      <SwiperSlide key={index}>
                        <div className="testimonial-card mb-5">
                          <p className="testimonial-text">
                            <FaQuoteLeft className="quote-icon" /> {feedback} <FaQuoteRight className="quote-icon" />
                          </p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              </Row>
            
            </Col>
          </Row>
        </div>
     
      </Container>

    </div>

</>
  );
}
